import { render, staticRenderFns } from "./MediaPropertyEdit.vue?vue&type=template&id=3f3e4e75&"
import script from "./MediaPropertyEdit.vue?vue&type=script&lang=ts&"
export * from "./MediaPropertyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports